import { SupplierFinance } from '@linktivity/gds-neo';

export const TransactionTypeMap =
  SupplierFinance.ListBookingTransactionsWithPageTransactionTypeEnum;

export const InvoiceStatus =
  SupplierFinance.ListInvoicesWithPageInvoiceStatusEnum;

export const InvoiceType = SupplierFinance.ListInvoicesWithPageInvoiceTypeEnum;
